import React from 'react';

type Styles = {
  readonly [key: string]: string;
};

export type ModeOption<T extends string> = {
  value: T;
  label: string;
};

type ModeToggleProps<T extends string> = {
  modes: ModeOption<T>[];
  current: T;
  onChange: (mode: T) => void;
  // CSS-модуль страницы. Ожидаются классы:
  // searchModeRow (обёртка), searchModeLabel (label слева), toggleButton, toggleButtonActive
  styles: Styles;
  // Текст слева перед кнопками. По умолчанию "Режим поиска:".
  modeLabel?: string;
};

// Переключатель режимов: лейбл слева + несколько кнопок справа.
// Активная кнопка получает класс toggleButtonActive.
export function ModeToggle<T extends string>({
  modes,
  current,
  onChange,
  styles,
  modeLabel = 'Режим поиска:',
}: ModeToggleProps<T>) {
  return (
    <div className={styles.searchModeRow}>
      <span className={styles.searchModeLabel}>{modeLabel}</span>
      {modes.map((m) => (
        <button
          key={m.value}
          type="button"
          className={`${styles.toggleButton} ${current === m.value ? styles.toggleButtonActive : ''}`}
          onClick={() => onChange(m.value)}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}

export default ModeToggle;
